import cookie from './cookie';

const showISDCaptcha = (responseObj, successCb) => {
    // eslint-disable-next-line new-cap
    const captcha = window.ISDCaptcha({
        element: 'ISDCaptcha', // 验证码组件需要绑定的元素ID
        width: responseObj.controlParams.width, // 图片宽度,需管理后台设置,不能再页面自定义，
        type: responseObj.level, // 验证码类型; 从SCF服务register接口中组件参数返回
        showType: 'win', // 展现形式;win:弹出，trigger:触发,embed:嵌入
        sessionId: responseObj.sessionId, // 从SCF服务register接口中返回
        targetElm: 'loginBtn',
        winAutoShow: true, // 弹出式时添加此属性会自动弹出,默认不自动弹出,点targetElm绑定的元素时弹出
        successCallback: function successCallback(data) {
            // 验证码验证成功后的回调函数
            cookie.set(
                'captcha_successToken',
                data.successToken,
                new Date(new Date().getTime() + 24 * 3600 * 1e3)
            );
            cookie.set(
                'captcha_sessionId',
                responseObj.sessionId,
                new Date(new Date().getTime() + 24 * 3600 * 1e3)
            );
            successCb();
            /** 在这里可以将验证成功后的sucesstoken保存至表单中;可以做提交表单的操作*/
        },
        failCallback: function failCallback(data) {
            console.log(data.responseId);
            // alert(data.responseId);//如果有校验错误时需要做的操作时，请在这里写。暂时不要在这里写回调
        }
    });
    captcha.init(); // 初始化组件
};

export { showISDCaptcha };
